import styled from 'styled-components';
import { rgba } from 'polished';

import { mainGridGapColor, cFFFFFF } from '#/colors';

import {
  DataTabs,
  TabData,
  Tabs,
  Tab,
  TabList,
  TabPanels,
  TabPanel,
} from '#/components/common/tabs';
import { gradientUnderline } from '#/components/shared/styles';
import { MEDIA } from '#/components/shared/media-queries';

import { OrderBookProvider } from '#/features/perpetuals/order-book/order-book-context';

import OrderBook from './OrderBook';
import TradeTape from './TradeTape';

const TABS: readonly TabData[] = [
  { id: 'order-book', label: 'Order Book', content: <OrderBook /> },
  { id: 'trade-tape', label: 'Trade Tape', content: <TradeTape /> },
];
const ORDER_BOOK_DEPTH = 10;

interface Props {
  readonly className?: string;
}

export default function OrderBookTradeTape(props: Props) {
  return (
    <OrderBookProvider depth={ORDER_BOOK_DEPTH}>
      <OrderBookTradeTapeContent {...props} />
    </OrderBookProvider>
  );
}

function OrderBookTradeTapeContent({ className }: Props) {
  return (
    <Container className={className} data-testid="order-book-trade-tape">
      <DataTabs
        data={TABS}
        containerComponent={StyledTabsContainer}
        tabComponent={StyledTab}
        tabListComponent={StyledTabList}
        tabPanelComponent={StyledTabPanel}
        tabPanelsComponent={StyledTabPanels}
      />
    </Container>
  );
}

const Container = styled.div`
  border-left: 1px solid ${mainGridGapColor};
  border-bottom: 1px solid ${mainGridGapColor};
`;

const StyledTabsContainer = styled(Tabs)`
  display: flex;
  height: 100%;
  flex: 1 1 0%;
  flex-direction: column;
`;

const StyledTab = styled(Tab)`
  color: ${rgba(cFFFFFF, 0.5)};
  padding: 0 16px;
  font-size: 13px;
  border-bottom: none;
  margin-bottom: -1px;
  flex-grow: 1;
  z-index: 1;

  &[data-selected] {
    color: ${cFFFFFF};
    ${gradientUnderline}
  }
`;

const StyledTabList = styled(TabList)`
  height: 39px;
  border-bottom: 1px solid ${mainGridGapColor};
  padding: 0 2px;
`;

const StyledTabPanels = styled(TabPanels)`
  display: flex;
  flex: 1 1 0%;
  z-index: 0; // allows the tab underline to stay on top
`;

const StyledTabPanel = styled(TabPanel)`
  flex: 1 1 0%;
  position: relative;

  /* 0px – md */
  overflow: hidden;

  @media ${MEDIA.md} {
    overflow: auto;
  }
`;
